import React, { useState, useEffect } from 'react';
import { Form, Tag, DatePicker, Select } from 'antd';
import { CloseCircleOutlined } from '@ant-design/icons';
import './partnerSeeAllApplicationsSort.css';
import PropTypes from 'prop-types';

import { Config } from '../../public/js/config';
import { Base } from '../../public/js/base';
import approveImg from '../../public/img/newMain/Approve.png';
import resetWhite from '../../public/img/newMain/resetWhite.png'
import context from '../../public/js/context';

/**
 * 消息提示组件
 * props传参如下
 * 消息提示类型,样式 ['error','success','warning','info']
 *                              error:错误提示框，红色样式
 *                              success:成功提示框，绿色样式
 *                              warning:警告提示框，黄色样式
 *                              info:普通提示框，蓝色样式
 */
let PartnerSeeAllApplicationsSort = ({ onOpenChange, isReset }) => {
    const [form] = Form.useForm();

    const [selectedConditions, setSelectedConditions] = useState({});
    const [sortOptions, setSortOptions] = useState([]);
    const [jobPostModel, setJobPostModel] = useState({});

    /**
     * 标题默认值处理
     */
    useEffect(() => {
        setSortOptions([
            {
                label: "",
                value: ""
            },
            {
                label: "Job Application ID",
                value: "job_appl_id"
            },
            {
                label: "Job ID",
                value: "job_id"
            },
            {
                label: "Job Title",
                value: "job_title"
            },
            {
                label: "Job Post Status",
                value: "job_post_status"
            },
            {
                label: "THEi Programme",
                value: "prog_title"
            },
            {
                label: "Student ID",
                value: "student_acct_id"
            },
            {
                label: "Student",
                value: "first_name"
            },
            {
                label: "Date Applied",
                value: "apply_date"
            },
            {
                label: "Status",
                value: "job_appl_status"
            },
            {
                label: "Attention Needed",
                value: "attention_needed"
            },
        ])
    }, []);

    useEffect(() => {
        if (isReset) {
            reset()
        }
    }, [isReset])


    const handleChange = (selectedOption) => {
        form.setFieldValue('orderBy', selectedOption)
    };

    const save = () => {
        form.validateFields().then(() => {
            selectedConditions['jobPostStatus'] ? jobPostModel.jobPostStatusListSearch = selectedConditions['jobPostStatus'] : "";
            selectedConditions['jobApplStatus'] ? jobPostModel.jobApplStatusListSearch = selectedConditions['jobApplStatus'] : "";
            jobPostModel.applyDateStartDate = form.getFieldValue('startDate');
            jobPostModel.applyDateEndDate = form.getFieldValue('endDate');
            jobPostModel.orderBy = form.getFieldValue('orderBy');
            onOpenChange(false, true, jobPostModel)
        })
    }

    const reset = () => {
        setSelectedConditions({});
        form.resetFields()
        setJobPostModel({})
    }

    const close = () => {
        onOpenChange(false, false)
    }

    const handleConditionClick = (condition, groupName) => {
        const updatedSelectedConditions = { ...selectedConditions };
        if (!updatedSelectedConditions[groupName]) {
            updatedSelectedConditions[groupName] = [];
        }

        const index = updatedSelectedConditions[groupName].indexOf(condition);
        if (index !== -1) {
            // 如果已选中，则移除
            updatedSelectedConditions[groupName].splice(index, 1);
        } else {
            // 如果未选中，则添加
            updatedSelectedConditions[groupName].push(condition);
        }

        setSelectedConditions(updatedSelectedConditions);
    };

    const isConditionSelected = (condition, groupName) => {
        if (selectedConditions[groupName]) {
            return selectedConditions[groupName].includes(condition);
        }
        return false;
    };

    const checkStartDate = (rule, value) => {
        if (Base.isNotEmpty(form.getFieldValue('endDate')) && Base.afterDate(form.getFieldValue('startDate'), form.getFieldValue('endDate'))) {
            return Promise.reject("The start date cannot be later than the end date.");
        }
        return Promise.resolve();
    }

    const checkEndDate = (rule, value) => {
        if (Base.isNotEmpty(form.getFieldValue('startDate')) && Base.afterDate(form.getFieldValue('startDate'), form.getFieldValue('endDate'))) {
            return Promise.reject("The end date cannot be earlier than the start date.")
        }
        return Promise.resolve();
    }

    return (
        <div className='partnerSeeAllApplicationsSort'>
            <Form form={form}>
                <div>
                    <div className='closePopover' onClick={close}><CloseCircleOutlined /></div>
                    <div className='Title'>
                        <span className='lable'>Job Post Status :</span>
                        {
                            context.jobPostStatusMap.map((item, index) =>
                                <Tag key={index} className={isConditionSelected(item.value, 'jobPostStatus') ? 'selected' : 'noSelected'} onClick={() => handleConditionClick(item.value, 'jobPostStatus')}>{item.label}</Tag>
                            )
                        }
                    </div>
                    <div className='Title' style={{ display: 'flex' }}>
                        <span className='lable'>Status :</span>
                        <div className='lableValue'>
                        {
                            context.partnerJobApplStatusMap.map((item, index) =>
                                <Tag key={index} className={isConditionSelected(item.value, 'jobApplStatus') ? 'selected' : 'noSelected'} onClick={() => handleConditionClick(item.value, 'jobApplStatus')}>{item.label}</Tag>
                            )
                        }
                        </div>
                    </div>
                    <div className='Title' style={{ marginBottom: '10px', display: 'flex' }}>
                        <span className='lable'>Date Applied :</span>
                        <span style={{ display: 'flex' }}>
                            <div>
                                <Form.Item
                                    name="startDate"
                                    rules={[// 声明式验证: 直接使用别人定义好的验证规则进行验证
                                        { validator: (rule, value) => checkStartDate(value) },
                                    ]}>
                                    <DatePicker
                                        placeholder=""
                                        className="timeDatePicker"
                                        allowClear={true}
                                        format={Config.dateFormatEn} />
                                </Form.Item>
                            </div>
                            <span style={{ margin: '0px 10px' }}>-</span>
                            <div>
                                <Form.Item
                                    name="endDate"
                                    rules={[// 声明式验证: 直接使用别人定义好的验证规则进行验证
                                        { validator: (rule, value) => checkEndDate(value) },
                                    ]}>
                                    <DatePicker
                                        placeholder=""
                                        className="timeDatePicker"
                                        allowClear={true}
                                        format={Config.dateFormatEn} />
                                </Form.Item>
                            </div>
                        </span>
                    </div>
                    <div className='Title' style={{ marginBottom: '10px', display: 'flex' }}>
                        <span className='lable'>Sort By :</span>
                        <Form.Item
                            name="orderBy"
                        >
                            <Select
                                onChange={handleChange}
                                options={sortOptions}
                            />
                        </Form.Item>
                    </div>
                </div>
            </Form>
            <div className='butArea'>
                <div className='saveButton' type="primary" onClick={save}><img src={approveImg} />Confirm</div>
                <div className='resetButton' onClick={reset}><img src={resetWhite} />Reset</div>
            </div>

        </div>
    )

}
PartnerSeeAllApplicationsSort.propTypes = {
    onOpenChange: PropTypes.func.isRequired,
    isReset: PropTypes.bool.isRequired,
};
export default PartnerSeeAllApplicationsSort;